import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Address} from '@app/core/models/java.model';


@Injectable({
  providedIn: 'root'
})
export class AddressService {
  private readonly URL_CUSTOMER = `${environment.apiURL}/client/addresses`;

  constructor(private readonly http: HttpClient) {
  }

  findAll(): Observable<Address[]> {
    return this.http.get<Address[]>(this.URL_CUSTOMER);
  }

  findByType(type:String): Observable<Address[]> {
    return this.http.get<Address[]>(this.URL_CUSTOMER);
  }

  findById(id:String): Observable<Address> {
    return this.http.get<Address>(this.URL_CUSTOMER);
  }

  findDefault(): Observable<Address> {
    return this.http.get<Address>(`${this.URL_CUSTOMER}/default`);
  }

  create(address: Address): Observable<Address> {
    return this.http.post<Address>(this.URL_CUSTOMER, address);
  }

  update(id: string, address: Address): Observable<Address> {
    return this.http.put<Address>(`${this.URL_CUSTOMER}/${id}`, address);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.URL_CUSTOMER}/${id}`);
  }

  setDefault(addressId: string): Observable<Address> {
    return this.http.put<Address>(`${this.URL_CUSTOMER}/${addressId}/default`, {});
  }
}
